function getRecentlyViewedProductsIds() {
    const recently_viewed = window.localStorage.getItem("recently_viewed");

    if (!recently_viewed) {
        window.localStorage.setItem("recently_viewed", "");
    }

    let ids = recently_viewed
        .split(",")
        .filter((id) => {
            return id;
        })
        .map((id) => +id);

    return ids.filter(function (id) {
        return id !== +window?.meta?.product?.id;
    });
}



function addToRecentlyViewedProducts(current_id) {
    if (!current_id) {
        return;
    }

    const recently_viewed = window.localStorage.getItem("recently_viewed");
    if (!recently_viewed) {
        window.localStorage.setItem("recently_viewed", "");
    }

    let recently_viewed_ids = [
        current_id,
        ...getRecentlyViewedProductsIds().filter((id) => {
            return id !== current_id;
        })
    ];

    window.localStorage.setItem("recently_viewed", recently_viewed_ids.join(","));
}

function addCurrentProductToRecentlyViewedProducts() {

    const current_id = +window?.meta?.product?.id;

    addToRecentlyViewedProducts(current_id);
}

addCurrentProductToRecentlyViewedProducts();

async function getRecentlyViewedProducts() {
    const ids = getRecentlyViewedProductsIds();
    const search = encodeURI(ids.map((id) => `id:${id}`).join(" OR "));

    const response = (
        await window.axios.get(`/search?q=${search}&type=product&view=products-json`)
    ).data;

    const html = document.createElement("div");
    html.innerHTML = response;

    const productsHTML =
        html.querySelector("[data-json-response]").innerHTML;
    return productsHTML;

}
async function getSectionProducts() {
    const productsJson = await getRecentlyViewedProducts();
    const products = JSON.parse(productsJson);
    if (!products.length) {
        return null;
    }

    let promises = [];

    products.forEach((product) => {
        promises.push(
            fetch(
                `/products/${product.handle}?view=product-new`
            ).then((data) => {
                if (data.status === 404) {
                    return null;
                }
                return data.text();
            })
        );
    });

    return await Promise.all(promises);
}


(async () => {

    const productsHtml = await getSectionProducts();
    const sliderWrapper = document.querySelector('#recently-viewed-products');

    if (productsHtml && sliderWrapper) {
        for (let i = 0; i < productsHtml.length; i++) {
            sliderWrapper.innerHTML += productsHtml[i];
        }
        document.querySelector(".recently-viewed.container").classList.remove("hidden")
    } 
})();